import React from "react";

const About = () => {
  return (
    <div>
      <div className="bg-teal-600 container mx-auto">SELAM</div>
    </div>
  );
};

export default About;
